import { object, number, boolean, mixed, string } from "./";

export const discountSchema = object().shape({
  amount: number().min(1, "bad_discount").max(99, "bad_discount").required(),
  for_client: boolean(),
  client: mixed().when("for_client", {
    is: true,
    then: mixed().required(),
    otherwise: mixed(),
  }),
  discount_type: string().required(),
  with_expires: boolean(),
  expires: mixed().when("with_expires", {
    is: true,
    then: mixed().required(),
    otherwise: mixed(),
  }),
});
